import React, { useEffect } from "react";
import Footer from "./Footer";
import Navbar from "../../Menu/Navbar";
import PageHeader from "../../../Components/layouts/PageHeader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import parse from "html-react-parser";
import { toGetTerms } from "../../../apis/actions/terms.actions";

const Terms = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const { list } = useSelector((state: RootState) => state.terms.terms);
  useEffect(() => {
    dispatch(toGetTerms(i18n.language));
  }, [dispatch]);
  return (
    <>
      <Navbar type="internal" />
      <main className="main">
        <PageHeader
          current={t("terms.title")}
          banner="assets/imgs/page-header/banner1.png"
          link="terms"
        />
        <section className="box-section-term background-body pt-85 pb-85">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 px-lg-5">
                <div className="d-flex flex-column gap-4">
                  {list.map((item: any, index: number) => (
                    <div className="content" key={index}>
                      <h3
                        className="text-xl-bold mb-2 neutral-1000"
                        id="Acceptance"
                      >
                        {item?.name}
                      </h3>
                      <h5
                        className="text-lg-bold mb-2 neutral-1000"
                        id="Acceptance"
                      >
                        {item?.summary}
                      </h5>
                      <p className="text-md-medium neutral-500">
                        {item.details && parse(item.details)}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer type="external" />
    </>
  );
};

export default Terms;
